/**
 * Scroll-to-top control — each <scroll-to-top> instance scrolls the window to top on click.
 * Multiple instances per page are supported; each only wires its own button.
 */

function prefersReducedMotion() {
  return window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches ?? false;
}

function scrollPageToTop() {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: prefersReducedMotion() ? "auto" : "smooth",
  });
}

class ScrollToTop extends HTMLElement {
  /** @type {HTMLButtonElement | null} */
  #button = null;

  /** @param {MouseEvent} e */
  #onClick = (e) => {
    e.preventDefault();
    scrollPageToTop();
  };

  connectedCallback() {
    this.#button = this.querySelector("button");
    if (!this.#button) return;
    this.#button.addEventListener("click", this.#onClick);
  }

  disconnectedCallback() {
    this.#button?.removeEventListener("click", this.#onClick);
    this.#button = null;
  }
}

if (!customElements.get("scroll-to-top")) {
  customElements.define("scroll-to-top", ScrollToTop);
}
